// Public Web Push certificate for the existing eladore-b9f28 Firebase project.
// This client-visible value is not the provider-managed private key.
export const DEFAULT_FCM_VAPID_KEY = "BFXRwD_dWOaYaVb46gW6xUlikWmNtzA32Af4N4dftHfD9R3LN-iKM80iCVEZunvLS61otNGpz0YIG9XFKNqP0hU";

export const validatePushVapidKey = (value) => {
  const key = typeof value === 'string' ? value.trim() : '';
  const invalid = () => new Error('Push notification configuration is invalid. Please try again later.');

  // An uncompressed P-256 public key is 65 bytes: 0x04 followed by x and y.
  // Require canonical, unpadded base64url; this validates format, not curve membership.
  if (!/^[A-Za-z0-9_-]{87}$/.test(key)) throw invalid();
  let decoded;
  try {
    decoded = atob(key.replace(/-/g, '+').replace(/_/g, '/') + '=');
  } catch {
    throw invalid();
  }
  if (decoded.length !== 65 || decoded.charCodeAt(0) !== 4 ||
      btoa(decoded).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '') !== key) {
    throw invalid();
  }
  return key;
};

export const resolvePushVapidKey = (override = process.env.REACT_APP_FCM_VAPID_KEY) => {
  const configured = typeof override === 'string' ? override.trim() : override;
  return validatePushVapidKey(configured === undefined || configured === null || configured === ''
    ? DEFAULT_FCM_VAPID_KEY
    : configured);
};
